import styled, { css } from "styled-components";
import { ReactSVG } from "react-svg";

export const Container = styled.div`
  max-width: 90%;
  margin: 0 auto;
`;

export const Card = styled.div`
  background: #fff;

  .boxSearch {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 25px auto;
  }

  .lupa {
    position: absolute;
    width: 26.1px;
    height: 26.1px;
    padding: 6.3px 1.8px 3.8px 3.3px;
    margin: 0 7px;
    z-index: 9;
  }

  .boxSearch > input {
    position: relative;
    width: 40%;
    height: 39px;
    padding: 6px 8px 6px 35px;
    border-radius: 6px;
    border: solid 1px #707070;
    background-color: #ffffff;

    @media only screen and (max-width: 500px) {
      width: 50%;
      height: 30px;
    }
  }

  .boxSearch Button {
    /* width: 148px; */
    height: 30px;
    font-size: 14px !important;
    margin-left: 10px;
    /* padding: 4px 17px; */
    border-radius: 6px;
    background-color: #00a2e0;

    @media only screen and (max-width: 500px) {
      width: 170px;
      height: 30px;
      font-size: 12px !important;
    }
  }

  @media only screen and (max-width: 855px) {
    .boxSearch {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
`;

export const CardHeader = styled.div`
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 2px #bbbbbb;

  ${({ theme }) => css`
    .border {
      border-left: 2px solid #bbbbbb;
      padding: 10px;
      color: ${theme.colors.gray};
      font-size: 1.3rem;
      width: 37%;
      height: auto;
      text-align: center;
    }
  `}

  @media only screen and (max-width: 500px) {
    .border {
      padding: 0;
      text-align: center;
      width: 44%;
    }
    span {
      font-size: 1.2rem;
    }
  }

  @media (min-width: 1600px) {
    .border {
      width: 35%;
    }
  }
`;

export const CardBody = styled.div`
  margin-top: 30px !important;
  .rodaPe{
	display: flex;
	flex-direction: row ;
	justify-content: space-between
  
  width: 100%;
  }
    .select{
    width: 50%;
    margin-right: 15px;
  }

  .select1{
    width: 22%;
    margin-right: 10px;
  }
`;

export const Custumer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.7rem;
  border-bottom: solid 1px #707070;

  .iconService {
    display: flex;
    align-items: center;
  }

  @media (max-width: 860px) {
    //overflow: scroll;
    position: relative;
    z-index: 9;
    flex-direction: column;
  }
  @media (max-width: 1500px) {
    flex-direction: column;
  }

  .iconService Button {
    display: flex;
    width: auto;
    height: 30px;
    padding: 10px;
    font-size: 10px !important;
    margin-right: 30px;
    border-radius: 6px;
    background-color: #00a2e0;
    align-items: center;
    justify-content: center;
  }
  .WrapperInativo {
    ${({ theme }) => css`
      width: 20%;
      margin-right: 8rem;
      .inativo {
        height: 2.8rem;
        width: 100%;
        background-color: white;
        border: 1px solid red;
        color: red;
        font-size: ${theme.font.sizes.medium};
        pointer-events: none;
      }
      @media (max-width: 1250px) {
        width: 30%;
      }
    `}
  }
`;

export const SvgIcon = styled(ReactSVG)`
  margin-right: 2rem;
  width: 3rem;
  height: 35.2px;
  margin: 4px 25.4px 4.6px 0;
  fill: #00a2e0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const SvgIconInvert = styled(ReactSVG)`
  width: 2.5rem;
  fill: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SvgIconDisabled = styled(ReactSVG)`
  margin-right: 2rem;
  width: 3rem;
  height: 35.2px;
  margin: 4px 25.4px 4.6px 0;
  fill: #cccccc !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  img {
    /* margin-right: 1rem; */
    width: 24.7px;
    height: 24.7px;
    margin: 0px 15px 0px 0px;
    object-fit: contain;
  }
  .dataCard {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  h4 {
    height: 15px;
    margin: 8px 35px 2px 5px;
    opacity: 0.9;
    font-family: Roboto;
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    -webkit-letter-spacing: normal;
    -moz-letter-spacing: normal;
    -ms-letter-spacing: normal;
    letter-spacing: normal;
    text-align: left;
    color: #747576;
  }

  .h4-info {
    color: #000000;
  }

  @media (max-width: 1500px) {
    width: 100%;
    .h4-info {
      width: auto;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 1em;
    }
  }

  @media (max-width: 860px) {
    width: 100%;
    .h4-info {
      width: auto;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 1em;
    }
  }
`;

export const SelectContainer = styled.div``;
